module.exports = "/images/cc.png?c535711acd27d8f212d53d6fac84c48f";